//无限循环列表（item大小不固定）但是只有单列 用于聊天
export class ScrollView {
    private m_scrollview: cc.ScrollView;
    private m_view: cc.Node;
    private m_content: cc.Node;
    private m_item_templates: { key: string, item: cc.Node }[];
    private m_node_pools: { key: string, items: cc.Node[] }[];

    private m_dir: number;
    private m_width: number;
    private m_height: number;
    private m_gap_x: number;
    private m_gap_y: number;
    private m_cb_host: any;
    private item_update_func: (item: cc.Node, key: string, data: any, index: number) => [number, number];
    private recycle_cb: (item: cc.Node, key: string) => void;
    private scroll_to_end_cb: () => void;
    private m_auto_scrolling: boolean;
    private m_items: ScrollItem[];
    private m_start_index: number;
    private m_stop_index: number;

    constructor(params: ScrollViewParams) {
        this.m_scrollview = params.scrollview;
        this.m_view = params.view;
        this.m_content = params.content;
        this.m_node_pools = [];
        this.m_item_templates = [];
        params.item_templates.forEach((tpl: ScrollItemTemplate) => {
            tpl.node.active = false;
            let item = { key: tpl.key, item: tpl.node }
            this.m_item_templates.push(item);
        });

        this.m_dir = params.direction || ScrollDirection.Vertical;
        this.m_width = params.width || this.m_view.width;
        this.m_height = params.height || this.m_view.height;
        this.m_gap_x = params.gap_x || 0;
        this.m_gap_y = params.gap_y || 0;
        this.m_cb_host = params.cb_host;
        this.item_update_func = params.item_update_func;
        this.recycle_cb = params.recycle_cb;
        this.scroll_to_end_cb = params.scroll_to_end_cb;
        this.m_auto_scrolling = params.auto_scrolling || false;

        if (this.m_dir == ScrollDirection.Vertical) {
            this.m_content.width = this.m_width;
        }
        else {
            this.m_content.height = this.m_height;
        }
        this.m_view.setContentSize(this.m_width, this.m_height);
        this.m_scrollview.vertical = this.m_dir == ScrollDirection.Vertical;
        this.m_scrollview.horizontal = this.m_dir == ScrollDirection.Horizontal;
        this.m_scrollview.inertia = true;
        this.m_scrollview.node.on("scrolling", this.on_scrolling, this);
        this.m_scrollview.node.on("scroll-to-bottom", this.on_scroll_to_end, this);
        this.m_scrollview.node.on("scroll-to-right", this.on_scroll_to_end, this);
    }

    set_data(datas: ScrollItemData[]) {
        this.clear_items();
        this.m_items = [];
        datas.forEach((data, index) => {
            let item: ScrollItem = this.pack_item(index, data);
            this.m_items.push(item);
        });
        this.layout_items(0);
        this.resize_content();
        this.m_start_index = -1;
        this.m_stop_index = -1;
        if (this.m_dir == ScrollDirection.Vertical) {
            this.m_content.y = 0;
        }
        else {
            this.m_content.x = 0;
        }
        if (this.m_items.length > 0) {
            this.on_scrolling();
        }
    }

    insert_data(index: number, ...datas: ScrollItemData[]) {
        if (datas.length == 0) {
            cc.log("nothing to insert");
            return;
        }
        if (!this.m_items) {
            this.m_items = [];
        }
        if (index < 0 || index > this.m_items.length) {
            cc.warn("invalid index", index);
            return;
        }
        let is_append: boolean = index == this.m_items.length;
        let items: ScrollItem[] = [];
        datas.forEach((data, index) => {
            let item: ScrollItem = this.pack_item(index, data);
            items.push(item);
        });
        this.m_items.splice(index, 0, ...items);
        this.layout_items(index);
        this.resize_content();
        this.m_start_index = -1;
        this.m_stop_index = -1;

        if (this.m_auto_scrolling && is_append) {
            this.scroll_to_end();
        }
        this.on_scrolling();
    }

    append_data(...datas: ScrollItemData[]) {
        if (!this.m_items) {
            this.m_items = [];
        }
        this.insert_data(this.m_items.length, ...datas);
    }

    scroll_to_end() {
        if (this.m_dir == ScrollDirection.Vertical) {
            this.m_scrollview.scrollToBottom();
        }
        else {
            this.m_scrollview.scrollToRight();
        }
    }

    destroy() {
        this.clear_items();
        let length = this.m_node_pools.length
        for (let i = 0; i < length; i++) {
            if (this.m_node_pools[i].items) {
                let count = this.m_node_pools[i].items.length
                for (let j = 0; j < count; j++) {
                    this.m_node_pools[i].items[j].destroy()
                }
            }
        }
        this.m_node_pools = null;
        this.m_items = null;

        if (cc.isValid(this.m_scrollview.node)) {
            this.m_scrollview.node.off("scrolling", this.on_scrolling, this);
            this.m_scrollview.node.off("scroll-to-bottom", this.on_scroll_to_end, this);
            this.m_scrollview.node.off("scroll-to-right", this.on_scroll_to_end, this);
        }
    }

    private on_scroll_to_end() {
        if (this.scroll_to_end_cb) {
            this.scroll_to_end_cb.call(this.m_cb_host);
        }
    }

    private on_scrolling() {
        if (!this.m_items || !this.m_items.length) {
            return;
        }
        if (this.m_dir == ScrollDirection.Vertical) {
            let posy: number = this.m_content.y;
            if (posy < 0) {
                posy = 0;
            }
            if (posy > this.m_content.height - this.m_height) {
                posy = this.m_content.height - this.m_height;
            }
            let start: number = 0;
            let stop: number = this.m_items.length - 1;
            let viewport_start: number = -posy;
            let viewport_stop: number = viewport_start - this.m_height;
            while (this.m_items[start].y - this.m_items[start].height > viewport_start) {
                start++;
            }
            while (this.m_items[stop].y < viewport_stop) {
                stop--;
            }
            if (start != this.m_start_index && stop != this.m_stop_index) {
                this.m_start_index = start;
                this.m_stop_index = stop;
                cc.log("render_from:", start, stop);
                this.render_items();
            }
        }
        else {
            let posx: number = this.m_content.x;
            if (posx > 0) {
                posx = 0;
            }
            if (posx < this.m_width - this.m_content.width) {
                posx = this.m_width - this.m_content.width;
            }
            let start: number = 0;
            let stop: number = this.m_items.length - 1;
            let viewport_start: number = -posx;
            let viewport_stop: number = viewport_start + this.m_width;
            while (this.m_items[start].x + this.m_items[start].width < viewport_start) {
                start++;
            }
            while (this.m_items[stop].x > viewport_stop) {
                stop--;
            }
            if (start != this.m_start_index && stop != this.m_stop_index) {
                this.m_start_index = start;
                this.m_stop_index = stop;
                cc.log("render_from:", start, stop);
                this.render_items();
            }
        }
    }

    private get_pools_by_key(key: string) {
        let length = this.m_node_pools.length
        for (let i = 0; i < length; i++) {
            if (this.m_node_pools[i].key == key) {
                return this.m_node_pools[i].items
            }
        }
        return null
    }

    private get_item_by_key(key: string) {
        let length = this.m_item_templates.length
        for (let i = 0; i < length; i++) {
            if (this.m_item_templates[i].key == key) {
                return this.m_item_templates[i].item
            }
        }
        return null
    }

    private spawn_node(key: string): cc.Node {
        let node: cc.Node;
        let pools: cc.Node[] = this.get_pools_by_key(key);
        if (pools && pools.length > 0) {
            node = pools.pop();
        }
        else {
            node = cc.instantiate(this.get_item_by_key(key));
            node.active = true;
        }
        node.parent = this.m_content;
        return node;
    }

    private recycle_item(item: ScrollItem) {
        if (item.node && cc.isValid(item.node)) {
            let pools: cc.Node[] = this.get_pools_by_key(item.data.key);
            if (!pools) {
                pools = [];
                this.m_node_pools.push({ key: item.data.key, items: pools });
            }
            pools.push(item.node);
            if (this.recycle_cb) {
                this.recycle_cb.call(this.m_cb_host, item.node, item.data.key);
            }
            item.node.removeFromParent();
            item.node = null;
        }
    }

    private clear_items() {
        if (this.m_items) {
            this.m_items.forEach((item) => {
                this.recycle_item(item);
            });
        }
    }

    private render_items() {
        let item: ScrollItem;
        for (let i: number = 0; i < this.m_start_index; i++) {
            item = this.m_items[i];
            if (item.node) {
                this.recycle_item(item);
            }
        }
        for (let i: number = this.m_items.length - 1; i > this.m_stop_index; i--) {
            item = this.m_items[i];
            if (item.node) {
                this.recycle_item(item);
            }
        }
        for (let i: number = this.m_start_index; i <= this.m_stop_index; i++) {
            item = this.m_items[i];
            if (!item.node) {
                item.node = this.spawn_node(item.data.key);
                this.item_update_func.call(this.m_cb_host, item.node, item.data.key, item.data.data, i);
            }
            item.node.setPosition(item.x, item.y);
        }
    }

    private pack_item(index: number, data: ScrollItemData): ScrollItem {
        let node: cc.Node = this.spawn_node(data.key);
        let [width, height]: [number, number] = this.item_update_func.call(this.m_cb_host, node, data.key, data.data, index);
        let item: ScrollItem = { x: 0, y: 0, width: width, height: height, data: data, node: node };
        this.recycle_item(item);
        return item;
    }

    private layout_items(start: number) {
        if (this.m_items.length <= 0) {
            return;
        }
        let start_pos: number = 0;
        if (start > 0) {
            let prev_item: ScrollItem = this.m_items[start - 1];
            if (this.m_dir == ScrollDirection.Vertical) {
                start_pos = prev_item.y - prev_item.height - this.m_gap_y;
            }
            else {
                start_pos = prev_item.x + prev_item.width + this.m_gap_x;
            }
        }
        for (let index: number = start, stop: number = this.m_items.length; index < stop; index++) {
            let item: ScrollItem = this.m_items[index];
            if (this.m_dir == ScrollDirection.Vertical) {
                item.x = 0;
                item.y = start_pos;
                start_pos -= item.height + this.m_gap_y;
            }
            else {
                item.y = 0;
                item.x = start_pos;
                start_pos += item.width + this.m_gap_x;
            }
        }
    }

    private resize_content() {
        if (this.m_items.length <= 0) {
            this.m_content.width = 0;
            this.m_content.height = 0;
            return;
        }
        let last_item: ScrollItem = this.m_items[this.m_items.length - 1];
        if (this.m_dir == ScrollDirection.Vertical) {
            this.m_content.height = Math.max(this.m_height, last_item.height - last_item.y);
        }
        else {
            this.m_content.width = Math.max(this.m_width, last_item.x + last_item.width);
        }
    }
}

export type ScrollItemTemplate = {
    key: string;
    node: cc.Node;
}

export type ScrollItemData = {
    key: string;
    data: any;
}

export enum ScrollDirection {
    Vertical = 1,
    Horizontal = 2,
}

type ScrollViewParams = {
    scrollview: cc.ScrollView;
    view: cc.Node;
    content: cc.Node;
    item_templates: ScrollItemTemplate[];
    direction?: ScrollDirection;
    width?: number;
    height?: number;
    gap_x?: number;
    gap_y?: number;
    cb_host?: any;
    item_update_func: (item: cc.Node, key: string, data: any, index: number) => [number, number];
    recycle_cb?: (item: cc.Node, key: string) => void;
    scroll_to_end_cb?: () => void;
    auto_scrolling?: boolean;
}

type ScrollItem = {
    x: number;
    y: number;
    width: number;
    height: number;
    data: ScrollItemData;
    node: cc.Node;
}